export default {
    state: {
        calls: [],
    },
    mutations: {
        addCall:  (state, client) => {
            state.calls.push(client)
        },
        popCall: (state) => {
            state.calls.pop()
        }
    },
    getters: {
        getCalls: (state) => state.calls,
    }
}
